import { object } from 'yup';

import { buildFields } from '../base/builders/buildValidationFields';

export default () => {
    const { name, parameters, parameters_hitch } = buildFields();

    return object().shape({
        name,
        parameters: object().shape({
            terms: parameters.terms,
        }),
        parameters_hitch,
    });
};
